export default __webpack_public_path__ + "static/media/mdShulInside.20c7a5be.jpg";